require('./warnAboutDeprecatedCJSRequire.js')('fetch');
module.exports = require('isomorphic-fetch');
